import { IEmployee, IUser } from "../api/api.interface";
import { IBlog } from "../types/blogs.type";
import { IBrand } from "../types/brands.type";
import { ICategory } from "../types/category.type";
import { IClient } from "../types/clients.type";
import { IDiscount } from "../types/discount.type";
import { IPhoneOrder } from "../types/phoneOrder.type";
import { IProduct } from "../types/product.type";
import { IProductType } from "../types/productType.type";
import { IResource } from "../types/resources.type";
import { ISelectsInput } from "../types/selects.type";
import { ISupplier } from "../types/suppliers.type";
import { ITags } from "../types/tags.type";

export const filterUsers = (users: IUser[], searchValue: string): IUser[] => {
  if (!searchValue) return users;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return users.filter(
    (user) =>
      (user.fullName &&
        user.fullName.toLowerCase().includes(lowercasedSearchValue)) ||
      (user.email &&
        user.email.toLowerCase().includes(lowercasedSearchValue)) ||
      (user.phone &&
        user.phone.toLowerCase().includes(lowercasedSearchValue)) ||
      (user.status &&
        user.status.toLowerCase().includes(lowercasedSearchValue)) ||
      (user.role && user.role.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterEmployees = (
  users: IEmployee[],
  searchValue: string
): IEmployee[] => {
  if (!searchValue) return users;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return users.filter(
    (user) =>
      (user.fullName &&
        user.fullName.toLowerCase().includes(lowercasedSearchValue)) ||
      (user.email &&
        user.email.toLowerCase().includes(lowercasedSearchValue)) ||
      (user.phone && user.phone.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterSuppliers = (
  suppliers: ISupplier[],
  searchValue: string
): ISupplier[] => {
  if (!searchValue) return suppliers;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return suppliers.filter(
    (supplier) =>
      (supplier.name &&
        supplier.name.toLowerCase().includes(lowercasedSearchValue)) ||
      (supplier.email &&
        supplier.email.toLowerCase().includes(lowercasedSearchValue)) ||
      (supplier.phone &&
        supplier.phone.toLowerCase().includes(lowercasedSearchValue)) ||
      (supplier.contactFullName &&
        supplier.contactFullName.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterResources = (
  resources: IResource[],
  searchValue: string
): IResource[] => {
  if (!searchValue) return resources;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return resources.filter(
    (resource) =>
      (resource.name &&
        resource.name.toLowerCase().includes(lowercasedSearchValue)) ||
      (resource.description &&
        resource.description.toLowerCase().includes(lowercasedSearchValue)) ||
      (resource.extinctionUnit &&
        resource.extinctionUnit
          .toLowerCase()
          .includes(lowercasedSearchValue)) ||
      (resource.note &&
        resource.note.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterWarehouse = (
  resources: IProduct[],
  searchValue: string
): IProduct[] => {
  if (!searchValue) return resources;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return resources.filter(
    (resource) =>
      resource.name &&
      resource.name.toLowerCase().includes(lowercasedSearchValue)
  );
};

// export const filterSelectItems = (
//   items: ISelectsInput[],
//   searchValue: string
// ) => {
//   if (!searchValue) return items;
//   const lowercasedSearchValue = searchValue.toLowerCase();

//   return items.filter(
//     (item) =>
//       (item.name && item.name.toLowerCase().includes(lowercasedSearchValue)) ||
//       (item.subName &&
//         item.subName.toLowerCase().includes(lowercasedSearchValue)) ||
//       (item.secondSubName &&
//         item.secondSubName.toLocaleLowerCase().includes(lowercasedSearchValue))
//   );
// };
export const filterSelectItems = (
  items: ISelectsInput[],
  searchValue: string
) => {
  if (!searchValue) return items;
  const searchWords = searchValue.toLowerCase().split(" ");

  return items.filter((item) => {
    console.log("item", item);
    const itemName = item.name ? item.name.toString().toLowerCase() : "";
    const itemSubName = item.subName
      ? item.subName.toString().toLowerCase()
      : "";
    const itemSecondSubName = item.secondSubName
      ? item.secondSubName.toString().toLowerCase()
      : "";

    return searchWords.every(
      (word) =>
        itemName.includes(word) ||
        itemSubName.includes(word) ||
        itemSecondSubName.includes(word)
    );
  });
};

export const filterClients = (
  clients: IClient[],
  searchValue: string
): IClient[] => {
  if (!searchValue) return clients;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return clients.filter(
    (client) =>
      (client.fullName &&
        client.fullName.toLowerCase().includes(lowercasedSearchValue)) ||
      (client.email &&
        client.email.toLowerCase().includes(lowercasedSearchValue)) ||
      (client.phone &&
        client.phone.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterProducts = (
  clients: IProduct[],
  searchValue: string
): IProduct[] => {
  if (!searchValue) return clients;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return clients.filter(
    (client) =>
      (client.name &&
        client.name.toLowerCase().includes(lowercasedSearchValue)) ||
      (client.description &&
        client.description.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterTags = (tags: ITags[], searchValue: string): ITags[] => {
  if (!searchValue) return tags;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return tags.filter(
    (resource) =>
      resource.name &&
      resource.name.toLowerCase().includes(lowercasedSearchValue)
  );
};

export const filterProductTypes = (
  types: IProductType[],
  searchValue: string
): IProductType[] => {
  if (!searchValue) return types;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return types.filter(
    (resource) =>
      resource.name &&
      resource.name.toLowerCase().includes(lowercasedSearchValue)
  );
};

export const filterCategories = (
  categories: ICategory[],
  searchValue: string
): ICategory[] => {
  if (!searchValue) return categories;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return categories.filter(
    (resource) =>
      resource.name &&
      resource.name.toLowerCase().includes(lowercasedSearchValue)
  );
};

export const filterBrands = (tags: IBrand[], searchValue: string): IBrand[] => {
  if (!searchValue) return tags;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return tags.filter(
    (resource) =>
      resource.name &&
      resource.name.toLowerCase().includes(lowercasedSearchValue)
  );
};

export const filterBlogs = (blogs: IBlog[], searchValue: string): IBlog[] => {
  if (!searchValue) return blogs;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return blogs.filter(
    (blog) =>
      (blog.title &&
        blog.title.toLowerCase().includes(lowercasedSearchValue)) ||
      (blog.slug && blog.slug.toLowerCase().includes(lowercasedSearchValue)) ||
      (blog.type && blog.type.toLowerCase().includes(lowercasedSearchValue)) ||
      (blog.status && blog.status.toLowerCase().includes(lowercasedSearchValue))
  );
};

export const filterDiscounts = (
  tags: IDiscount[],
  searchValue: string
): IDiscount[] => {
  if (!searchValue) return tags;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return tags.filter(
    (resource) =>
      resource.percent &&
      resource.percent.toLowerCase().includes(lowercasedSearchValue)
  );
};

export const filterPhoneOrder = (
  tags: IPhoneOrder[],
  searchValue: string
): IPhoneOrder[] => {
  if (!searchValue) return tags;

  const lowercasedSearchValue = searchValue.toLowerCase();
  return tags.filter(
    (resource) =>
      resource.client.fullName &&
      resource.client.fullName.toLowerCase().includes(lowercasedSearchValue)
  );
};
